module.exports = __webpack_public_path__ + "img/xy.ec5e4163.png";